class SimpleEmpreendimentosService {
    baseUrlEmpreendimentos = route('web.empreendimentos.simple.json');


    extractValuesArray = (array) => {
        let newArray = [];

        array.forEach((element) => {
            newArray.push(element.value)
        });

        return newArray;
    }

    extractValuesArrayFromCidade = (array) => {
        let newArray = [];

        array.forEach((element) => {
            let elementParts = element.value.split('-');
            let cidade = elementParts[1].trim();
            newArray.push(cidade)
        });

        return newArray;
    }

    getEmpreendimentosWithinPolygon = async (path, state) => {
        let { tipo_empreendimento, padrao, area_maior_que, area_menor_que,
            quartos, status, valor_menor_que, valor_maior_que,
            valor_metro_maior_que, valor_metro_menor_que, cidade, estado,
            bairros, ano_lancamento, incorporadoras, nome_empreendimento,
            juros_minimo, juros_maximo, parcelas_minimo, parcelas_maximo,
            valor_parcela_maxima, valor_parcela_minima, porcentagem_vendida_minima, porcentagem_vendida_maxima,
            estagio, mes_ano_lancamento, retrofit, regiao, check_incluir_monitoradas, cluster
        } = state;

        status = status.length > 0 ? status : ['Comercialização', 'Esgotado', 'Futuro'];
        let bairro = bairros;
        let nome = this.extractValuesArray(nome_empreendimento);
        cidade = this.extractValuesArrayFromCidade(cidade)
        incorporadoras = this.extractValuesArray(incorporadoras)
        let area_util_maior_que = area_maior_que;
        let area_util_menor_que = area_menor_que;
        const requestBody = {
            ano_lancamento,
            area_util_maior_que,
            area_util_menor_que,
            bairro,
            cidade,
            cluster,
            estado,
            estagio,
            incorporadoras,
            juros_maximo,
            juros_minimo,
            mes_ano_lancamento,
            nome,
            padrao,
            parcelas_maximo,
            parcelas_minimo,
            polygon: path,
            quartos,
            status,
            tipo_empreendimento,
            valor_maior_que,
            valor_menor_que,
            valor_metro_maior_que,
            valor_metro_menor_que,
            valor_parcela_maxima,
            valor_parcela_minima,
            porcentagem_vendida_minima,
            porcentagem_vendida_maxima,
            retrofit,
            regiao,
            check_incluir_monitoradas
        }

        try {
            return await axios.post(this.baseUrlEmpreendimentos, requestBody);

        } catch (error) {
            console.log('error');
        }

    }

    getEmpreendimentosWithinRadius = async (latitude, longitude, radius, state) => {
        let { tipo_empreendimento, padrao, area_maior_que, area_menor_que,
            quartos, status, valor_menor_que, valor_maior_que,
            valor_metro_maior_que, valor_metro_menor_que, cidade, estado,
            bairros, ano_lancamento, incorporadoras, nome_empreendimento,
            juros_minimo, juros_maximo, parcelas_minimo, parcelas_maximo,
            valor_parcela_maxima, valor_parcela_minima, porcentagem_vendida_minima, porcentagem_vendida_maxima,
            retrofit, estagio, mes_ano_lancamento, regiao, check_incluir_monitoradas , cluster} = state;

        status = status.length > 0 ? status : ['Comercialização', 'Esgotado', 'Futuro'];
        let bairro = bairros;
        let nome = this.extractValuesArray(nome_empreendimento);
        cidade = this.extractValuesArrayFromCidade(cidade);
        incorporadoras = this.extractValuesArray(incorporadoras);
        let area_util_maior_que = area_maior_que;
        let area_util_menor_que = area_menor_que;

        const requestBody = {
            ano_lancamento,
            area_util_maior_que,
            area_util_menor_que,
            bairro,
            cidade,
            circle: {
                'latitude': latitude,
                'longitude': longitude,
                'radius': radius,
            },
            cluster,
            estado,
            incorporadoras,
            juros_maximo,
            juros_minimo,
            mes_ano_lancamento,
            nome,
            padrao,
            parcelas_maximo,
            parcelas_minimo,
            quartos,
            status,
            tipo_empreendimento,
            valor_maior_que,
            valor_menor_que,
            valor_metro_maior_que,
            valor_metro_menor_que,
            valor_parcela_maxima,
            valor_parcela_minima,
            porcentagem_vendida_minima,
            porcentagem_vendida_maxima,
            estagio,
            retrofit,
            regiao,
            check_incluir_monitoradas,
        }

        try {
            return await axios.post(this.baseUrlEmpreendimentos, requestBody);

        } catch (error) {
            console.log('Erro ao Buscar Empreendimentos');
            console.log(error);
        }
    }

    getEmpreendimentoOnCidade = async (state) => {
        let { tipo_empreendimento, padrao, area_maior_que, area_menor_que,
            quartos, status, valor_menor_que, valor_maior_que,
            valor_metro_maior_que, valor_metro_menor_que, cidade, estado,
            bairros, ano_lancamento, incorporadoras, nome_empreendimento,
            juros_minimo, juros_maximo, parcelas_minimo, parcelas_maximo,
            valor_parcela_maxima, valor_parcela_minima, porcentagem_vendida_minima, retrofit,
            porcentagem_vendida_maxima, estagio, mes_ano_lancamento, check_incluir_monitoradas, regiao, cluster
        } = state;

        status = status.length > 0 ? status : ['Comercialização', 'Esgotado', 'Futuro'];
        let nome = this.extractValuesArray(nome_empreendimento);
        cidade = this.extractValuesArrayFromCidade(cidade)
        incorporadoras = this.extractValuesArray(incorporadoras)
        let area_util_maior_que = area_maior_que;
        let area_util_menor_que = area_menor_que;
        let bairro = bairros;

        const requestBody = {
            ano_lancamento,
            area_util_maior_que,
            area_util_menor_que,
            bairro,
            cidade,
            cluster,
            estado,
            estagio,
            incorporadoras,
            juros_maximo,
            juros_minimo,
            mes_ano_lancamento,
            nome,
            padrao,
            parcelas_maximo,
            parcelas_minimo,
            porcentagem_vendida_maxima,
            porcentagem_vendida_minima,
            quartos,
            regiao,
            retrofit,
            status,
            tipo_empreendimento,
            valor_maior_que,
            valor_menor_que,
            valor_metro_maior_que,
            valor_metro_menor_que,
            valor_parcela_maxima,
            valor_parcela_minima,
            check_incluir_monitoradas
        }

        try {
            return await axios.post(this.baseUrlEmpreendimentos,
                requestBody
            );

        } catch (error) {
            console.log('Erro ao Buscar Empreendimentos');
            console.log(error);
        }
    }
}

export default new SimpleEmpreendimentosService();
